import type { FilterValue } from "@/lib/types/marketsuite/datatypes/filters";
import type { MsFilterSet, MsRangeFilterContent } from "@/payload-types";
import { FILTER_TYPE_DEFINITIONS, type FilterDefinition } from "./registry";

export const FILTER_TYPES_BY_SLUG = new Map<string, FilterDefinition>(FILTER_TYPE_DEFINITIONS.map((d) => [d.slug, d]));

export function buildFilterDefaultValues(filterset: MsFilterSet | null | undefined, configuredDefaults?: Record<string, string>): Record<string, unknown> {
	const values: Record<string, unknown> = {};

	for (const block of filterset?.filters ?? []) {
		const slug = block.blockType;
		const configured = configuredDefaults?.[slug];

		if (!configured) continue;

		const definition = FILTER_TYPES_BY_SLUG.get(slug);

		if (definition?.kind === "range") {
			const content: MsRangeFilterContent = block.content;
			const parts = configured
				.split(",")
				.map((p) => parseInt(p.trim()))
				.filter((p) => !isNaN(p));

			values[slug] = content.mode === "range" && parts.length === 2 ? parts : parts[0];
			continue;
		}

		values[slug] = configured
			.split(",")
			.map((entry) => entry.trim())
			.filter(Boolean);
	}

	return values;
}

export function buildRangeFilterDefaults(filters: MsFilterSet["filters"] | undefined): Record<string, FilterValue> {
	const defaults: Record<string, FilterValue> = {};

	for (const [slug, value] of Object.entries(buildFilterDefaultValues({ filters } as MsFilterSet))) {
		if (FILTER_TYPES_BY_SLUG.get(slug)?.kind === "range") {
			defaults[slug] = value as FilterValue;
		}
	}

	return defaults;
}
